<currency-input
  (valueChange)="valueChange($event)"
  [value]="formControl.value"
  [currencyFormat]="props.currencyFormat"
  [currencySymbol]="props.currencySymbol"
  [disabled]="props.disabled || formControl.disabled"
  [key]="field.dataId"
  [placeholder]="props.placeholder"
/>
